export const ProductCategoryDropDown = [
    {name:'Over Count',value:'overcount'},{name : 'Under Count',value:'undercount'},{name : 'G1',value:'g1'},{name : 'G2',value:'g2'},
    {name : 'Cut',value:'cut'},{name : 'RJ(Rejections)',value:'rj'}
]

export enum ProductCategoryEnum {
    overcount = 'Over Count',
    undercount = 'Under Count',
    g1 = 'G1',
    g2 = 'G2',
    cut = 'Cut',
    rj = 'RJ(Rejections)',
}